import React from 'react'
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { containerVariants, itemVariants } from "../../variants/variants";

const Section2 = () => {
    const { t } = useTranslation();

    return (
        <motion.div 
            initial="hidden"
            whileInView="visible"
            exit="exit"
            variants={containerVariants}
            className='grid grid-cols-1 md:grid-cols-2'>


            <div className="  ">
                <motion.h1 variants={itemVariants} className=" text-65  text-customBlack mb-5 ">
                {t("socialResponsibility.genderEquality.title")}
                </motion.h1>

                <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5 mb-14 md:w-[80%]">
                    {t("socialResponsibility.genderEquality.text")}
                </motion.p>

            </div>

            <div className='' >
                <motion.img variants={itemVariants} src='/images/social-responsibility/s.png' className='h-full w-full object-contain' />
            </div>
        </motion.div>
    )
}

export default Section2
